import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      name: '',
      status: '',
    },
    configuration: {
      name: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'advertisers::filters.dropdown.items.name.label',
        placeholder: 'advertisers::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      status: {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'secondary-33'}
            color={'basic-primary-white'}
          />
        ),
        label: 'advertisers::filters.dropdown.items.status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix:
          'advertisers::filters.dropdown.items.status.options.',
        options: ['active', 'archived'],
      },
    },
  }
}
